module.exports = __webpack_public_path__ + "img/kuraray_PPT2_CN.7dd29e0e.jpg";